<script setup lang="ts">
import { Dropdown } from "bootstrap";

import ToolbarButton from "./ToolbarButton.vue";

const props = withDefaults(
  defineProps<{
    id: string;
    disabled?: boolean;
    buttonAriaLabel?: string;
    buttonAttrs?: Record<string, unknown>;
    fixedMinWidth?: boolean;
    border?: boolean;
    align?: "left" | "right";
  }>(),
  {
    disabled: false,
    buttonAriaLabel: "",
    buttonAttrs: () => ({}),
    fixedMinWidth: false,
    border: false,
    align: "left",
  }
);
const emit = defineEmits(["show"]);

const dropdownElement = ref<HTMLElement>();
let dropdown: Dropdown | null = null;

onMounted(() => {
  if (dropdownElement.value) {
    dropdown = new Dropdown(dropdownElement.value);
    dropdownElement.value.addEventListener("show.bs.dropdown", function () {
      emit("show");
    });
  }
});

onBeforeUnmount(() => {
  if (dropdown) {
    dropdown.dispose();
  }
});

const styles = computed(() => {
  return {
    minWidth: props.fixedMinWidth ? "" : "auto",
  };
});
</script>

<template>
  <div
    class="dropdown d-flex align-items-center"
    :class="{ 'dropdown--border': border }"
  >
    <ToolbarButton
      :id="`dropdown-button-${id}`"
      class="w-100"
      :disabled="disabled"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :aria-label="buttonAriaLabel"
      v-bind="buttonAttrs"
    >
      <slot name="button">Menu</slot>
      <div class="d-flex">
        <i class="bi bi-chevron-down ms-1 font-xs"></i>
      </div>
    </ToolbarButton>
    <ul
      class="dropdown-menu"
      :class="{ 'dropdown-menu-end': align === 'right' }"
      :aria-labelledby="`dropdown-button-${id}`"
      :style="styles"
    >
      <slot name="default"></slot>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.dropdown--border {
  border-radius: 2px;
  background-color: rgb(0 0 0 / 2.5%);
}
</style>
